import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';

declare var $: any;

@Component({
    selector: 'app-fact-auto',
    templateUrl: './fact-auto.component.html',
    styleUrls: ['./fact-auto.component.css'],
    standalone: false
})
export class FactAutoComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();

  factauto = {};
  avoirAuto = {};
  selected = [];
  selectedAchat = [];
  dataArticle = [];
  listChantier = [];
  listeAgence = [];
  listeSite = [];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  condition1: Boolean = false;
  condition2: Boolean = false;
  condition3: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  devise;
  pays = '';
  suuceaAvoir: Boolean = false;
  succesFact: Boolean = false;
  focusIndex = 0;
  focusIndexAchat = 0;
  societe: any = {};
  frequence = [
    { id: '1', libelleObjetEntite: 'Mensuelle' },
    { id: '2', libelleObjetEntite: 'Trimestrielle' },
    { id: '3', libelleObjetEntite: 'Semestrielle' },
    { id: '6', libelleObjetEntite: 'Bimestrielle' },
    { id: '4', libelleObjetEntite: 'Annuelle' },
    { id: '5', libelleObjetEntite: 'A la création de la facture' },
  ];
  listFactAutoFact = [];
  listFactAutoAchat = [];
  ongletData: any = {}
  listeDate = [];
  objDefault = { id: 0, libelleObjetEntite: 'Tous' };

  @ViewChild('msg') msg;
  error = '';


  constructor(public common: CommonService, private modalService: BsModalService) {
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise;
    this.adresseAchat = this.common.local.getObject('paramSociete').adresseAchat;
  }

  ngOnInit() {
    for (let i = 1; i <= 31; i++) {
      this.listeDate.push({ id: i, libelleObjetEntite: '' + i });
    }
    this.getListeAgence();
    this.getListFactauto().then(data => {
      this.isEmpty = false;
      this.searchSite();
      if (data.length) {
        data[0].listLignes = data[0].listLignes || [];
        data[1].listLignes = data[1].listLignes || [];
        if (data[0].listLignes.length) {
          data[0].listLignes.forEach(f => {
            if (f.debutPeriode) {
              f.debutPeriodeTemp = f.debutPeriode.slice(0, 5);
            }
            if (f.finPeriode) {
              f.finPeriodeTemp = f.finPeriode.slice(0, 5);
            }
          });
        }

        if (data[1].listLignes.length) {
          data[1].listLignes.forEach(f => {
            if (f.debutPeriode) {
              f.debutPeriodeTemp = f.debutPeriode.slice(0, 5);
            }
            if (f.finPeriode) {
              f.finPeriodeTemp = f.finPeriode.slice(0, 5);
            }
          });
        }

        data[0].date = data[0].date ? moment(data[0].date, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '';
        data[0].echeance = data[0].echeance ? moment(data[0].echeance, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '';
        this.factauto = data[0];
        this.avoirAuto = data[1];
        this.avoirAuto['listLignes'] = this.avoirAuto['listLignes'] || [];
        this.parseDate();
      }
    });
  }

  rederTable() {
    this.renderTable = false;
    setTimeout(() => {
      this.renderTable = true;
    }, 5)
  }

  getpays(id) {
    let elt;
    this.common.getType('typePays').forEach(elem => {
      if (elem.id === id) {
        elt = elem;
      }
    });
    return elt;
  }

  parseDate() {
    this.listFactAutoFact = this.getLigneAffiche(true);
    this.factauto['listLignes'] = this.getLigneAffiche();
    this.factauto['listLignes'].forEach(elt => {
      elt.dateDebut = elt.dateDebut ? moment(elt.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '01/01/2000';
      elt.dateFin = elt.dateFin ? moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '31/12/9999';
    });
    this.listFactAutoAchat = this.getLigneAfficheAchat(true);
    this.avoirAuto['listLignes'] = this.getLigneAfficheAchat();
    this.avoirAuto['listLignes'].forEach(elt => {
      elt.dateDebut = elt.dateDebut ? moment(elt.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '01/01/2000';
      elt.dateFin = elt.dateFin ? moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '31/12/9999';
    });
  }

  getCellClass({ row, column, value }): any {
    return {
      'isEndDatePassed': moment(row.dateFin, 'DD/MM/YYYY').isBefore(moment())
    };
  }

  getCellClass2({ row, column, value }): any {
    return {
      'nonImprimeFactAuto': moment(row.dateFin, 'DD/MM/YYYY').isBefore(moment())
    };
  }


  hideFactAuto() {
    this.show.emit();
  }

  searchSite() {
    this.listeSite = this.common.local.getObject('listeSite') || [];
    this.listeSite.forEach(elt => elt.libelleObjetEntite = elt.nom);
  }

  getListFactauto() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBGetLigneFactAuto',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [this.detail]
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      return datas.data || [];
    });
  }

  onDrag(event) {
    event.dragstart = true;
  }

  onDrop(event) {
    const newData = event.slice();
    newData.forEach(elt => elt.dragstart = false);
    this.selected = [];
    this.focusIndex = 0;

    this.renderTable = false;
    this.factauto['listLignes'] = [];

    setTimeout(() => {
      this.factauto['listLignes'] = [...newData];
      this.renderTable = true;
    }, 0);
  }

  selectRow(row) {
    this.focusIndex = this.factauto['listLignes'].indexOf(row);
    this.selected = [row];
  }

  inserteLigne() {
    const objet = {
      id: '1', dateDebut: moment().format('DD/MM/YYYY'),
      dateFin: '31/12/9999'
    }
    const societe = this.common.local.getObject('paramSociete') || {};
    if (societe.factAutoParSite) {
      const site = this.listeSite.filter(elt => elt.id === this.common.user[2]);
      objet['site'] = site.length ? site[0] : { id: 0 };
    }
    this.factauto['listLignes'].splice(this.focusIndex, 0, objet);
    this.factauto['listLignes'] = [...this.factauto['listLignes']];
    const ctrl = this;
    setTimeout(function () {
      $('.article' + (ctrl.focusIndex)).focus();
    }, 600);
  }

  deleteLigne(row) {
    const temp = this.factauto['listLignes'].filter(elt => elt !== row);
    this.factauto['listLignes'] = temp;
  }

  addLigne() {
    const objet = {
      index: this.factauto['listLignes'].length, id: '1',
      dateDebut: moment().format('DD/MM/YYYY'), dateFin: '31/12/9999'
    }
    const societe = this.common.local.getObject('paramSociete') || {};
    if (societe.factAutoParSite) {
      const site = this.listeSite.filter(elt => elt.id === this.common.user[2]);
      objet['site'] = site.length ? site[0] : { id: 0 };
    }
    this.factauto['listLignes'].push(objet);
    this.factauto['listLignes'] = [...this.factauto['listLignes']];
    const length = this.factauto['listLignes'].length - 1;
    setTimeout(function () {
      $('.article' + (length)).focus();
    }, 600);
  }


  onDragAchat(event) {
    event.dragstart = true;
  }

  onDropAchat(event) {
    const newData = event.slice();
    newData.forEach(elt => elt.dragstart = false);
    this.selectedAchat = [];
    this.focusIndexAchat = 0;

    this.renderTable = false;
    this.avoirAuto['listLignes'] = [];

    setTimeout(() => {
      this.avoirAuto['listLignes'] = [...newData];
      this.renderTable = true;
    }, 0);
  }

  selectRowAchat(row) {
    this.focusIndexAchat = this.avoirAuto['listLignes'].indexOf(row);
    this.selected = [row];
  }

  inserteLigneAchat() {
    const objet = {
      id: '1', dateDebut: moment().format('DD/MM/YYYY'),
      dateFin: '31/12/9999'
    }
    const societe = this.common.local.getObject('paramSociete') || {};
    if (societe.avoirAutoParSite) {
      const site = this.listeSite.filter(elt => elt.id === this.common.user[2]);
      objet['site'] = site.length ? site[0] : { id: 0 };
    }
    this.avoirAuto['listLignes'].splice(this.focusIndexAchat, 0, objet);
    this.avoirAuto['listLignes'] = [...this.avoirAuto['listLignes']];
    const ctrl = this;
    setTimeout(function () {
      $('.article' + (ctrl.focusIndexAchat)).focus();
    }, 600);
  }

  deleteLigneAchat(row) {
    const temp = this.avoirAuto['listLignes'].filter(elt => elt !== row);
    this.avoirAuto['listLignes'] = temp;
  }

  addLigneAchat() {
    const objet = {
      index: this.avoirAuto['listLignes'].length, id: '1',
      dateDebut: moment().format('DD/MM/YYYY'), dateFin: '31/12/9999'
    }
    const societe = this.common.local.getObject('paramSociete') || {};
    if (societe.avoirAutoParSite) {
      const site = this.listeSite.filter(elt => elt.id === this.common.user[2]);
      objet['site'] = site.length ? site[0] : { id: 0 };
    }
    this.avoirAuto['listLignes'].push(objet);
    this.avoirAuto['listLignes'] = [...this.avoirAuto['listLignes']];
    const length = this.avoirAuto['listLignes'].length - 1;
    setTimeout(function () {
      $('.article' + (length)).focus();
    }, 600);
  }

  searchArticle(event) {
    this.dataArticle = [];
    const param = 4;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = datas.data;
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  setValue(event, row?) {
    this.getDetailArticle(event.id, row).then(data => {
      row['article'] = data !== null ? data[0] : {};
      row.modifArticle = true;
      row.libelle = data !== null ? data[0].libelle : '';
      row.tarif = data !== null ? data[0].tarif : '';
      row.txTVA = data !== null ? data[0].tva : '';
      row.unite = {
        id: row['article'].clefUnite,
        libelle: row['article'].unite,
      }
      row.typeTarif = data !== null ? data[0].typeTarif : '';

      // row.dateDebut = moment(row.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
      console.log(row);
      if (row.qte && row.tarif) {
        row.prixHT = row.qte * row.tarif;
      } else {
        row.prixHT = 0;
      }
    });
  }

  getDetailArticle(id, row) {
    const clef = '' + id;
    const date = row.dateDebut || moment().format('DD/MM/YYYY');
    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetArticle', clef, this.detail ? this.detail['id'] : 0, this.factauto['date'],
        row['chantier'] ? row['chantier'].id : 0, row.qte, (row.typeContenant ? row.typeContenant.id : 0),
        (row.articleContenu ? row.articleContenu.id : 0), this.detail['exutoire'] ? this.detail['exutoire'].id : 0,
        this.common.user[2], '0']
    };
    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  searchChantier(event) {
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        },
        'CRITERE': event || ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        const tous = this.societe['isBAKRI'] ? [{ id: 0, libelleObjetEntite: '1 Fact par détenteur' }] :
          [{ id: 0, libelleObjetEntite: 'Tous' }]
        this.listChantier = [...tous, ...datas.data || []];
      }
    });
  }

  getListeAgence() {
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        },
        'CRITERE': ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listeAgence = [...[{ id: 0, libelleObjetEntite: 'Tous' }], ...(datas.data || [])];
      }
    });
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  calculMontant(row) {
    if (row.qte && row.tarif) {
      row.prixHT = row.qte * row.tarif;
    } else {
      row.prixHT = 0;
    }
  }



  updateFactAuto(notHide?) {
    this.succesFact = false;
    this.suuceaAvoir = false;
    this.factauto['nomclass'] = 'Facture';
    this.avoirAuto['nomclass'] = 'Facture';
    let i = 0
    if (this.avoirAuto && this.avoirAuto['listLignes'] && this.avoirAuto['listLignes'].length) {
      this.suuceaAvoir = this.validationAvoirAuto(i, notHide)
    } else {
      this.suuceaAvoir = true;
    }
    if (this.factauto && this.factauto['listLignes'] && this.factauto['listLignes'].length) {
      this.succesFact = this.validationFactAuto(i, notHide)
    } else {
      this.succesFact = true;
    }

    if (this.suuceaAvoir && this.succesFact) {

      const param = {
        'servlet': 'DBMAJLigneFactAuto',
        'module': 'Recylog',
        'type': 'liste',
        'compression': 'false',
        'data': [[this.factauto, this.avoirAuto], '' + this.common.user[2]]
      };
      return this.common.post('', { param: param }, true).then(datas => {
        if (!notHide) {
          this.hideFactAuto();
        }
      });
    }

  }


  validationFactAuto(i, nothide?) {
    let isSiteNotposition = false;
    let isPeriodOExceeds = false;
    let isDateDebutValid = false;
    let isDateFinValid = false;
    const lengthFactAuto = this.factauto['listLignes'].length - 1;
    if (this.factauto['listLignes'] && lengthFactAuto >= i) {
      const listeLigneElt = this.factauto['listLignes'][i];
      if (listeLigneElt.debutPeriodeTemp) {
        listeLigneElt.debutPeriode = listeLigneElt.debutPeriodeTemp + '/1970';
        isDateDebutValid = moment(listeLigneElt.debutPeriode, 'DD/MM/YYYY', true).isValid()
      } else {
        listeLigneElt.debutPeriode = '';
        isDateDebutValid = true;
      }

      if (listeLigneElt.finPeriodeTemp) {
        listeLigneElt.finPeriode = listeLigneElt.finPeriodeTemp + '/1970';
        isDateFinValid = moment(listeLigneElt.finPeriode, 'DD/MM/YYYY', true).isValid()
      }
      else {
        listeLigneElt.finPeriode = '';
        isDateFinValid  =true
      }

      if (!listeLigneElt.site) {
        isSiteNotposition = true;
      }
      if (listeLigneElt.finPeriode && listeLigneElt.debutPeriode) {
        if (moment(listeLigneElt.finPeriode, 'DD/MM/YYYY').isBefore(moment(listeLigneElt.debutPeriode, 'DD/MM/YYYY'))) {
          isPeriodOExceeds = true;
        }
      }

      if (isSiteNotposition) {
        if (isSiteNotposition) {
          this.error = 'Vous devez positionner un site sur les lignes de facturation automatique.'
          this.common.openModal(this.modalService, this.msg);
          return false;
        }
      }

      if (isPeriodOExceeds) {
        this.error = 'La période fin ne peut pas être antérieure à celle de debut'
        this.common.openModal(this.modalService, this.msg);
        return false;
      }

      if (!isDateFinValid || !isDateDebutValid) {
        this.error = 'Le champs période doit être au  format jj/mm.'
        this.common.openModal(this.modalService, this.msg);
        return false;
      }

      i++;
      return this.validationFactAuto(i);
    } else {
      return true;
    }

  }


  validationAvoirAuto(i, nothide?) {
    let isSiteNotposition = false;
    let isPeriodOExceeds = false;
    let isDateDebutValid = false;
    let isDateFinValid = false;
    const lengthAvoirAuto = this.avoirAuto['listLignes'].length - 1;

    if (this.avoirAuto['listLignes'] && lengthAvoirAuto >= i) {
      const listeLigneElt = this.avoirAuto['listLignes'][i];

      if (listeLigneElt.debutPeriodeTemp) {
        listeLigneElt.debutPeriode = listeLigneElt.debutPeriodeTemp + '/1970';
        isDateDebutValid = moment(listeLigneElt.debutPeriode,'DD/MM/YYYY', true).isValid()
      } else {
        listeLigneElt.debutPeriode = '01/01/2000';
        isDateDebutValid = true;
      }

      if (listeLigneElt.finPeriodeTemp) {
        listeLigneElt.finPeriode = listeLigneElt.finPeriodeTemp + '/1970';
        isDateFinValid = moment(listeLigneElt.finPeriode,'DD/MM/YYYY',true).isValid()
      } else {
        listeLigneElt.finPeriode = '01/01/2000';
        isDateFinValid = true;
      }

      if (!listeLigneElt.site) {
        isSiteNotposition = true;
      }
      if (listeLigneElt.finPeriode && listeLigneElt.debutPeriode) {
        if (moment(listeLigneElt.finPeriode, 'DD/MM/YYYY').isBefore(moment(listeLigneElt.debutPeriode, 'DD/MM/YYYY'))) {
          isPeriodOExceeds = true;
        }
      }

      if (isSiteNotposition) {
          this.error = 'Vous devez positionner un site sur les lignes de facturation automatique.'
          this.common.openModal(this.modalService, this.msg);
          return false
      }
      if (!isDateFinValid || !isDateDebutValid ) {
        this.error = 'Le champs période doit être au  format jj/mm.'
        this.common.openModal(this.modalService, this.msg);
        return false
      }

      if (isPeriodOExceeds) {
        this.error = 'La période fin ne peut pas être antérieure à celle de debut'
        this.common.openModal(this.modalService, this.msg);
        return false
      }


      i++;
      return this.validationAvoirAuto(i)

    } else {
      return true;
    }
  }


  getLigneAffiche(isHisto?) {
    const societe = this.common.local.getObject('paramSociete') || {};
    this.factauto['listLignes'] = this.factauto['listLignes'] || []
    const liste = !isHisto ? this.factauto['listLignes'].filter(elt => !elt.histo)
      : this.factauto['listLignes'].filter(elt => elt.histo);

    let listDef = [];
    if (societe.factAutoParSite) {
      listDef = liste.filter(elt => elt.site && elt.site.id === this.common.user[2]);
    } else {
      listDef = liste;
    }

    return listDef;
  }

  getLigneAfficheAchat(isHisto?) {
    const societe = this.common.local.getObject('paramSociete') || {};
    this.avoirAuto['listLignes'] = this.avoirAuto['listLignes'] || []
    const liste = !isHisto ? this.avoirAuto['listLignes'].filter(elt => !elt.histo)
      : this.avoirAuto['listLignes'].filter(elt => elt.histo);

    let listDef = [];
    if (societe.factAutoParSite) {
      listDef = liste.filter(elt => elt.site && elt.site.id === this.common.user[2]);
    } else {
      listDef = liste;
    }

    return listDef;
  }

  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);
    const row = this.selected[0] || { id: 0 };
    this.selectRow(row)
  }

  onSelectAchat({ selected }) {
    console.log('Select Event', selected, this.selectedAchat);
    const row = this.selectedAchat[0] || { id: 0 };
    this.selectRowAchat(row)
  }

  genererFacture() {
    this.updateFactAuto(true).then(data => {
      this.factauto['nomclass'] = 'Facture';
      this.avoirAuto['nomclass'] = 'Facture';
      if (this.factauto['listLignes']) {
        this.factauto['listLignes'].forEach(elt => elt.nomclass = 'LigneFacture');
      }
      if (this.avoirAuto['listLignes']) {
        this.avoirAuto['listLignes'].forEach(elt => elt.nomclass = 'LigneFacture');
      }

      const param = {
        'servlet': 'DBGenererFactAutoDatePart',
        'module': 'Recylog',
        'type': 'liste',
        'compression': 'false',
        'data': [[this.factauto, this.avoirAuto], '' + this.common.user[2], {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        }]
      };

      return this.common.post('', { param: param }, true).then(datas => {
        this.hideFactAuto();
      });
    });
  }

  changeDateModel(event, row, type) {
    if (moment(event).isValid()) {
      row[type] = moment(event).format('DD/MM/YYYY');
    } else {
      row[type] = !event ? moment().format('DD/MM/YYYY') : '';
    }
  }

}
